import { black, errorRed } from './../utilities';
export const dataKeyBeginningDelimiter = '[';
// import { noDataFoundMessage } from './constants';
export const dataKeyEndingDelimiter = ']';

export const leadingAndTrailingDelimiterRegEx = /[.[\]]/g;

export const func = 'fn';

export const currency = 'currency';

export const contentType = {
  image: 'image',
  buttons: 'buttons',
  text: 'text',
  dateTime: 'datetime',
  tableButtons: 'tableButtons',
  modalButton: 'modalButton',
};

export const noDataFoundMessage = {
  icon: { name: 'motorcycle', color: black },
  primaryMessage: {
    message: 'Oops, it appears we were not able to find any [topic] 🤔',
    color: black,
  },
  secondaryMessage: { message: 'Please try again!', color: black },
  tertiaryMessage: {
    message:
      'If you feel this is a mistake, you may wish to contact technical support.',
    color: errorRed,
  },
};

export const providerSettings = {
  messaging: {
    noDataFoundMessage,
  },
};

export const ruleEvaluationMessage =
  'An error occurred while evaluating a rule style expression';
export const ruleStyleMissingMessage =
  'Missing a required style object from rule style';
export const emptyRowStateJsonMessage =
  'Invalid json object of { row, state } to obtain the data value from';
